import { useState, useEffect } from "react";
import { useFormik } from "formik";
import { useLocation } from "react-router-dom";
import { getTrackingBoxeRoute } from "../../../../config";
import { format } from 'date-fns';
import React from 'react';

const PURPLE = "#6138A2";
const GOLD   = "#FFBA00";

const TrackingPublico = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const _id = query.get('id');

  const [record, setRecord]         = useState(null);
  const [loading, setLoading]       = useState(false);
  const [notFound, setNotFound]     = useState(false);

  const getBoxTracking = async (id_box) => {
    if (!id_box || id_box === "") return;
    try {
      setLoading(true);
      setNotFound(false);
      setRecord(null);
      const res = await fetch(getTrackingBoxeRoute(id_box), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      });
      if (res.ok) {
        const data = await res.json();
        const sorted = [...data].sort((a, b) => new Date(a.history_date) - new Date(b.history_date));
        setRecord(sorted);
      } else if (res.status === 404) {
        setNotFound(true);
      }
    } catch (e) {
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: { recordId: '' },
    onSubmit: (values) => getBoxTracking(values.recordId),
  });

  useEffect(() => {
    if (_id) {
      formik.setFieldValue('recordId', _id, false);
      getBoxTracking(_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id]);

  const formatDateTime = (value) => {
    const date = new Date(value);
    return isNaN(date) ? "" : format(date, 'dd/MM/yyyy HH:mm');
  };

  return (
    <div style={{
      backgroundColor: PURPLE,
      minHeight: "100vh",
      padding: "32px 20px 64px",
      fontFamily: "'Segoe UI', Roboto, sans-serif",
      boxSizing: "border-box",
    }}>
      {/* Título */}
      <div style={{ marginBottom: "24px" }}>
        <h1 style={{ color: "white", margin: 0, fontSize: "2rem", fontWeight: "bold" }}>
          Tracking
        </h1>
        <p style={{ color: GOLD, margin: "6px 0 0", fontSize: "1rem" }}>
          Ingrese el código de su caja para consultar el estado
        </p>
      </div>

      {/* Formulario */}
      <form onSubmit={formik.handleSubmit} style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap", marginBottom: "28px" }}>
        <input
          type="text"
          name="recordId"
          placeholder="Código de caja"
          value={formik.values.recordId}
          onChange={formik.handleChange}
          style={{
            padding: "10px 18px",
            borderRadius: "25px",
            border: `2px solid ${GOLD}`,
            backgroundColor: "white",
            color: "#1a1a1a",
            fontSize: "1rem",
            outline: "none",
            minWidth: "220px",
          }}
        />
        <button
          type="submit"
          style={{
            backgroundColor: GOLD,
            color: PURPLE,
            border: "none",
            borderRadius: "25px",
            padding: "10px 28px",
            fontWeight: "bold",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        >
          Buscar
        </button>
      </form>

      {/* Loading */}
      {loading && (
        <p style={{ color: "white", fontSize: "1rem" }}>Buscando...</p>
      )}

      {/* No encontrado */}
      {notFound && !loading && (
        <div style={{
          backgroundColor: "white",
          borderRadius: "25px",
          padding: "24px 28px",
          color: "#555",
          fontSize: "1rem",
        }}>
          No encontramos información para este código.
        </div>
      )}

      {/* Resultados */}
      {record && record.length > 0 && !loading && (
        <div style={{
          backgroundColor: "white",
          borderRadius: "25px",
          overflow: "hidden",
        }}>
          {/* Header de tabla */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 140px",
            backgroundColor: PURPLE,
            padding: "10px 16px",
            color: "white",
            fontWeight: "bold",
            fontSize: "0.9rem",
          }}>
            <span>Descripción</span>
            <span>Estado</span>
            <span>Fecha y hora</span>
          </div>

          {/* Filas */}
          {record.map((row, index) => (
            <div
              key={row.id}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 140px",
                padding: "10px 16px",
                backgroundColor: index % 2 === 0 ? "white" : "#f5f0fb",
                color: "#1a1a1a",
                fontSize: "0.9rem",
                borderBottom: index < record.length - 1 ? "1px solid #e8e0f5" : "none",
              }}
            >
              <span>{row.description_status}</span>
              <span>{row.status}</span>
              <span style={{ whiteSpace: "nowrap" }}>{formatDateTime(row.history_date)}</span>
            </div>
          ))}

          {/* Footer */}
          <div style={{
            backgroundColor: PURPLE,
            padding: "8px 16px",
            color: "white",
            fontSize: "0.8rem",
          }}>
            {record.length} evento{record.length !== 1 ? "s" : ""}
          </div>
        </div>
      )}
    </div>
  );
};

export default TrackingPublico;
